import "@hprofits/shared/errors";
import "@orpc/contract";
import "../errors/utils.js";
import { ERROR_MESSAGES as E, TRANSPARENT_ERROR_CODES as e } from "./constants.js";
const a = (r, o, s = E.UNEXPECTED) => {
  const t = o?.(r);
  return t || (i(r.errorCode) ? r.message : s);
}, i = (r) => e.has(r);
export {
  a as buildErrorMessage,
  i as isTransparentError
};
//# sourceMappingURL=utils.js.map
